<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="col-sm-6 pdr5">
    <div class="inspection-content">
        <h1>{{locoLabel?.qInspection}}</h1>
        <table class="table four-col-tbl" *ngIf="tab?.mode!='edit'">
            <tbody>
                <tr>
                    <td>{{locoLabel?.deadDate}}</td>
                    <td><strong>{{locoData?.deadDate|locoBlankString}}</strong></td>
                    <td>{{locoLabel?.lastLocation}}</td>
                    <td><strong>{{locoData?.lastQLocation|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextDate}}</td>
                    <td><strong>{{locoData?.nextQDate|locoBlankString}}</strong></td>
                    <td>{{locoLabel?.lastDate}}</td>
                    <td><strong>{{locoData?.lastQDate|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextMaintainance}}</td>
                    <td><strong>{{locoData?.maintenanceType|locoBlankString}}</strong></td>
                    <td>{{locoLabel?.oneEightyFourM}}</td>
                    <td><strong>{{(locoData?.oneEightyFourMFlag && locoData?.oneEightyFourMFlag === 'Y') ? 'Y':'-'}}</strong></td>
                </tr>
            </tbody>
        </table>
        <table class="table four-col-tbl" *ngIf="tab?.mode==='edit'" [formGroup]="locoInspectionForm">
            <tbody>
                <tr>
                    <td>{{locoLabel?.deadDate}}</td>
                    <td><strong>{{locoData?.deadDate|locoBlankString}}</strong></td>
                    <td>{{locoLabel?.lastLocation}}</td>
                    <td><strong>{{locoData?.lastQLocation|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextDate}}</td>
                    <td *ngIf="locoData?.permanentTag!=='FL'"><strong>{{locoData?.nextQDate|locoBlankString}}</strong></td>
                    <td class="next-date-edit" *ngIf="locoData?.permanentTag==='FL'">
                        <lms-lms-calender styleClass="{{errorMap.get('nextQDateError')?'p-inputfield-error':''}}" formControlName="nextQDate" [minDate]='minNextDateValue'
                            readonlyInput='true' [showIcon]="true" dataType="string"></lms-lms-calender>
                    </td>
                    <td>{{locoLabel?.lastDate}}</td>
                    <td><strong>{{locoData?.lastQDate|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextMaintainance}}</td>
                    <td><strong>{{locoData?.maintenanceType|locoBlankString}}</strong></td>
                    <td>{{locoLabel?.oneEightyFourM}}</td>
                    <td><strong>{{(locoData?.oneEightyFourMFlag && locoData?.oneEightyFourMFlag === 'Y') ? 'Y':'-'}}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="col-sm-3 pdl5 pdr5">
    <div class="inspection-content">
        <h1>{{locoLabel?.otherInspection}}</h1>
        <table class="table two-col-tbl" *ngIf="tab?.mode!='edit'">
            <tbody>
                <tr>
                    <td>{{locoLabel?.next33Day}}</td>
                    <td><strong>{{locoData?.nextDailyMIDueDate|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextAirFlow}}</td>
                    <td><strong>{{locoData?.nextAirFlowDate|locoBlankString}}</strong></td>
                </tr>
            </tbody>
        </table>
        <table class="table two-col-tbl" *ngIf="tab?.mode==='edit'" [formGroup]="locoInspectionForm">
            <tbody>
                <tr>
                    <td>{{locoLabel?.next33Day}}</td>
                    <td *ngIf="locoData?.permanentTag!=='FL'"><strong>{{locoData?.nextDailyMIDueDate|locoBlankString}}</strong></td>
                    <td class="next-date-edit" *ngIf="locoData?.permanentTag==='FL'">
                        <lms-lms-calender styleClass="{{errorMap.get('nextDailyMIDueDateError')?'p-inputfield-error':''}}" formControlName="nextDailyMIDueDate"
                            [minDate]='minNext33DaysDateValue' readonlyInput='true' [showIcon]="true" dataType="string"></lms-lms-calender>
                    </td>
                </tr>
                <tr>
                    <td>{{locoLabel?.nextAirFlow}}</td>
                    <td *ngIf="locoData?.permanentTag!=='FL'"><strong>{{locoData?.nextAirFlowDate|locoBlankString}}</strong></td>
                    <td class="next-date-edit" *ngIf="locoData?.permanentTag==='FL'">
                        <lms-lms-calender styleClass="{{errorMap.get('nextAirFlowDateError')?'p-inputfield-error':''}}" formControlName="nextAirFlowDate"
                            [minDate]='minNextAirFlowDateValue' readonlyInput='true' [showIcon]="true" dataType="string"></lms-lms-calender>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="col-sm-3 pdl5">
    <div class="inspection-content">
        <h1>{{locoLabel?.locomotiveMates}}</h1>
        <table class="table two-col-tbl">
            <tbody>
                <tr>
                    <td>{{locoLabel?.powerUnit}}</td>
                    <td><strong>{{locoData?.powerUnitId|locoBlankString}}</strong></td>
                </tr>
                <tr>
                    <td>{{locoLabel?.mate}}</td>
                    <td><strong>{{locoData?.mateUnitId|locoBlankString}}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>